import { Injectable, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
 */
@Pipe({ name: 'dateFormatFilter' })
@Injectable()
export class DateFormatPipe implements PipeTransform {
    transform(date: any, format: string): any {
        if (date) {
            return moment(date).format(format);
        }
    }
}
